export class OcrResourceLoadError extends Error {
  readonly code = 'OCR_RESOURCE_UNAVAILABLE'

  constructor(message: string) {
    super(message)
    this.name = 'OcrResourceLoadError'
  }
}

export function isOcrResourceLoadError(error: unknown): error is OcrResourceLoadError {
  return error instanceof OcrResourceLoadError
    || (typeof error === 'object' && error !== null && 'code' in error && error.code === 'OCR_RESOURCE_UNAVAILABLE')
}

export async function sha256Hex(bytes: Uint8Array): Promise<string> {
  const payload = new Uint8Array(bytes.byteLength)
  payload.set(bytes)
  const digest = await crypto.subtle.digest('SHA-256', payload)
  return [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, '0')).join('')
}

export function hashesEqual(actual: string, expected: string): boolean {
  return actual.toLowerCase() === expected.toLowerCase()
}

export async function verifySha256(bytes: Uint8Array, expected: string): Promise<boolean> {
  return hashesEqual(await sha256Hex(bytes), expected)
}

export function contentLengthExceedsLimit(contentLength: string | null, maxBytes: number): boolean {
  if (!contentLength) return false
  if (!/^\d+$/.test(contentLength)) return false
  return Number(contentLength) > maxBytes
}
